'use strict';

angular.module('app.performanceReportMentionTimeline', [])
    .directive('performanceReportMentionTimelineDirective', function () {
        return {
            controller: 'performanceReportMentionTimelineCtrl',
            templateUrl: 'app/measure/performanceReport/performanceReportMentionTimeline/performanceReportMentionTimeline.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })